import React, { useState } from 'react';
import '../css/Modal.css';
import Translate, { t } from "./Translate";
import { getCurrentUser } from "../services/authService";

const currentUser = getCurrentUser() ? getCurrentUser() : { language: 'en' };

const ChangesModal = ({ isOpen, onClose, data }) => {

    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.newResourceKey]) {
            acc[item.newResourceKey] = [];
        }
        acc[item.newResourceKey].push(item);
        return acc;
    }, {});

    const [openKeys, setOpenKeys] = useState({});

    const toggleOpen = (key) => {
        setOpenKeys(prev => ({ ...prev, [key]: !prev[key] }));
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3><Translate language={currentUser.language} text={'changesOverview'} /></h3>

                <div className="data-container">
                    {Object.keys(groupedData).map(key => (
                        <div key={key} className="resource-group">
                            <button className="resource-key" onClick={() => toggleOpen(key)}>
                                <span><strong>{key}</strong></span>
                            </button>

                            <div className={`locale-container ${openKeys[key] ? 'show' : ''}`}>
                                {groupedData[key].map(item => (
                                    <div key={item.id} className="data-card">
                                        <p className='locale-p'>
                                            <strong><Translate language={currentUser.language} text={'locale'} />:</strong>
                                            <span className='locale-circle'>{item.locale}</span>
                                        </p>
                                        <p><strong><Translate language={currentUser.language} text={'newValue'} />:</strong> {item.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <button className="modal-button cancel" onClick={onClose}>
                    <Translate language={currentUser.language} text={'close'} />
                </button>
            </div>
        </div>
    );
};

export default ChangesModal;
